export default {
  exposeConfigDebugMethod: true,
  logOIDC: true,
  UAMlink: "https://accessmanager.austin.hp.com/uam/ProfileRequest.aspx?ProFlag=True&ProfileID=57562&",
  cognitoDomain: "https://localdev-daas-portal.auth-fips.us-west-2.amazoncognito.com",
  cognitoRegion: "us-west-2",
  cognitoPoolId: "us-west-2_GP4CoVNpG",
  cognitoClientId: "65h9vp94kvcand0citvsf9j7p6",
  hpidUrl: "https://directory.stg.cd.id.hp.com",
  editProfileEmployee: " https://directoryworks.hpicorp.net",
  editProfileNonEmployee: "https://myaccount.stg.cd.id.hp.com",
  launchDarklyReactKey: "61495270a3f8b125cd27b5f4",
  allowLocalStorageFlagOverrides: true,
  jupiterStack: "local",
  testEmailNote: true,
  enableEmbeddedAccessories: true,
  launchDarklyReactKeyForMssi: "6225e6a3fec7c614d613c080",
};
